import type { Action } from 'redux';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const UpdateIsAnalyticsTagsStepVisited = new ReduxAsyncAction<
  'UPDATE_IS_ANALYTICS_TAGS_STEP_VISITED',
  boolean,
  { isAnalyticsTagsStepVisited: boolean }
>('UPDATE_IS_ANALYTICS_TAGS_STEP_VISITED');

UpdateIsAnalyticsTagsStepVisited.registerRequest(async (isAnalyticsTagsStepVisited: boolean) => {
  return { isAnalyticsTagsStepVisited };
});

export const UPDATE_IS_ANALYTICS_TAGS_STEP_VISITED = UpdateIsAnalyticsTagsStepVisited.actionNamespaceConstants;

export const updateIsAnalyticsTagsStepVisited = UpdateIsAnalyticsTagsStepVisited.request;

export type UpdateIsAnalyticsTagsStepVisitedResponseAction = Action<
  typeof UPDATE_IS_ANALYTICS_TAGS_STEP_VISITED.response
> & {
  data: { isAnalyticsTagsStepVisited: boolean };
};
